import { Outlet } from 'react-router-dom';

import RootLayout from '@/layouts/RootLayout';

/**
 * Router-level layout route element: provides the `<Outlet />` for all
 * non-`noRootLayout` routes, wrapped in {@link RootLayout}. (Distinct from
 * gpm-ui's visual `AppLayout` shell used inside DashboardLayout.)
 */
export function AppLayout() {
  return (
    <RootLayout>
      <Outlet />
    </RootLayout>
  );
}
